<template>

    <!-- news lineups draft items list -->
    <div class="p-grid p-mx-auto">
        <div class="p-col-12 p-md-10 p-mx-auto">
            <div class="p-grid">
                <div class="p-col-3"></div>
                <div class="p-col-6">
                    <Paginator
                        :rows="drafts.itemPerPage"
                        :rowsPerPageOptions="drafts.itemsPerPageOptions"
                        :totalRecords="drafts.totalCount"
                        :first="drafts.firstItemIndex"
                        v-show="!drafts.isLoading && !isDraftListEmpty"
                        @page="onPage($event)" />
                </div>

                <div class="p-col-3 p-mt-2">
                    <Button
                        label="Create"
                        icon="pi pi-plus"
                        @click="toggleDraftForm()"
                        class="p-button-raised p-button p-button-text" />
                </div>
            </div>

            <ProgressBar mode="indeterminate" v-show="drafts.isLoading" style="height: .2em" />

            <div v-show="!drafts.isLoading && !isDraftListEmpty">
                <div v-for="(draftObject, index) in drafts.items"
                    :key="draftObject.id"
                    class="p-grid p-jc-center box p-mt-4">
                    <div class="p-col-12 p-md-3">
                        <img class="p-mt-2" :src="draftObject.imageUrl" style="max-width:70%;" />
                        <br/>
                        <div v-if="draftObject.eventImage !== undefined && draftObject.eventImage !== null">
                            <div style="position: relative;">
                                <img class="event-image-home-logo" :src='this.getEventImageTeamLogo(draftObject.eventImage, "home")' />
                                <img :src="this.getEventImageSrc(draftObject.eventImage)" class="notification-picture" />
                                <img class="event-image-away-logo" :src='this.getEventImageTeamLogo(draftObject.eventImage, "away")' />
                            </div>
                        </div>
                        <div class="p-text-left">
                            <span class="p-text-bold" style="font-size: 0.9rem;">
                                News Lineups Draft #{{draftObject.id}}
                            </span>
                            <p class="news-details-date-value" v-show="draftObject.teams !== null" style="color:lightgray">
                                News Teams: <span class="p-text-bold">{{draftObject.teams}}</span>
                            </p>
                            <p class="news-details-date-value" v-show="draftObject.ssEventInfo !== null" style="color:lightgray">
                                News Event: <span class="p-text-bold">{{draftObject.ssEventInfo}} <span v-show="draftObject.ssEventId !== null">({{draftObject.ssEventId}})</span></span>
                            </p>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-9 p-text-left p-pl-4">
                        <div class="p-col-12 p-md-12 p-text-right">
                            <Button label="Options" aria-haspopup="true" aria-controls="overlay_menu"
                                class="p-button-text p-button-info" icon="pi pi-ellipsis-v"
                                @click="toggleOptions($event, draftObject, index)"  />
                            <Menu id="overlay_menu" :ref="(el) => setMenuRef(el, index)" :model="draftOptionsMenu.items" :popup="true" />
                        </div>
                        <div id="news_content_container" style="overflow: hidden;">
                            <h2>{{draftObject.title}}</h2>
                            <p class="p-text-bold">
                                {{draftObject.subtitle}}
                            </p>
                            <p class="p-text-light news-content-small"
                                v-html="draftObject.content"
                                id="news_content"
                                :ref="'news_content_'+draftObject.id">
                            </p>
                        </div>
                    </div>
                    
                    <Divider class="p-pt-2 p-pb-2"/>

                    <div class="p-col-12 p-md-3">
                        <img class="p-mt-2" :src="draftObject.notificationImageUrl" style="max-width:40%;" />
                        <div class="p-text-left">
                            <p class="news-details-date-value" v-show="draftObject.ssTeamId !== null" style="color:lightgray">
                                Notification Categories:<br/>
                                <span class="p-text-bold">
                                    {{draftObject.newsNotificationCategoriesNames}}
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-9 p-text-left p-pl-4">
                        <b>Notification</b>
                        <div id="notification_content_container" style="overflow: hidden;">
                            <h2>{{draftObject.notificationTitle}}</h2>
                            <p class="p-text-bold">
                                {{draftObject.notificationSubtitle}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <ProgressBar mode="indeterminate" v-show="drafts.isLoading" style="height: .2em" />

            <Paginator 
                :rows="drafts.itemPerPage"
                :rowsPerPageOptions="drafts.itemsPerPageOptions"
                :totalRecords="drafts.totalCount"
                :first="drafts.firstItemIndex"
                v-show="!drafts.isLoading && !isDraftListEmpty"
                @page="onPage($event)" />

            <p v-show="isDraftListEmpty">
                No draft is found.
            </p>
        </div>
    </div>

    <!-- draft form -->
    <!-- <transition name="expand"> -->
    <Dialog modal maximizable v-model:visible="draftForm.isDraftFormVisible" class="p-col-12 p-md-10 p-mx-auto"
        :header="draftForm.mode === 'edit' ? 'Update News Lineups Draft' : 'Add News Lineups Draft'">
        <div class="p-grid p-text-left">
            <div class="p-field p-col-12 p-md-3 p-text-center">
                <label for="teams">Event Selection</label><br/>
                <Button
                    :label="popupEventSelection.selectedEvent?.event_info ?? 'Select Event'"
                    @click="popupSelectEvent()" />
            </div>
            <div class="p-field p-col-12 p-md-9">
                <label for="teams">Team Selection (max. 2)</label>
                <br/>
                <AutoComplete id="teams"
                    aria-describedby="teams-help"
                    forceSelection
                    v-model="selectedTeams"
                    :multiple="true"
                    :dropdown="(selectedTeams !== null && selectedTeams.length < 2)"
                    :delay="200"
                    :suggestions="filteredTeams"
                    @complete="searchTeams($event)" field="name" />
                <br/>
                <small id="teams-help">First two teams are saved. Others ignored</small>
            </div>
        </div>
        <div class="p-grid p-text-left">
            <div class="p-col-12 p-md-2">
                <Image imageClass="notification-picture p-d-inline" preview
                    style="width:80% !important;"
                    :src="draftForm.draft.imageUrl !== null && draftForm.draft.imageUrl !== undefined 
                        && draftForm.draft.imageUrl.length > 0 ? draftForm.draft.imageUrl : newPictureDefaultPlaceholder"/>
            </div>
            <div class="p-col-12 p-md-10">
                <div class="p-field">
                    <label for="img_url">Image Url</label>
                    <InputText id="img_url" @input="onImageUrlPaste()" type="text" v-model="draftForm.draft.imageUrl" style="width:96%;" />
                </div>
                <div class="p-field">
                    <label for="title">Title</label><br/>
                    <Textarea id="title" type="text" rows="1" :autoResize="true" v-model="draftForm.draft.title" style="width:96%;" />
                </div>
                <div class="p-field">
                    <label for="subtitle">Subtitle</label><br/>
                    <Textarea id="subtitle" type="text" rows="2" :autoResize="true" v-model="draftForm.draft.subtitle" style="width:96%;" />
                </div>
                <div class="p-field">
                    <div class="flex align-items-center">
                        <Checkbox v-model="draftForm.draft.isMiddlePageAdEnabled" id="middle_page_ad_enabled" name="isMiddlePageAdEnabled" :binary="true" />
                        <label for="middle_page_ad_enabled" class="p-ml-2"> 
                            <img class="icon-mini" src="../assets/admob-icon.png" /> Middle Page Ad Enabled (Ad is visible between subtitle and news content)
                        </label>
                    </div>
                </div>
                <div class="p-field">
                    <label for="content">News content</label><br/>
                    <Textarea class="" id="content" :autoResize="true" v-model="draftForm.draft.content" style="width:96%;" />
                </div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-field p-col-6 p-md-4">
                <div class="p-col-12">
                    <Checkbox v-model="draftForm.draft.event_image_enabled" id="event_image_enabled" name="event_image_enabled" @change="eventImageEnabledChanged()" :binary="true" />
                    <label for="event_image_enabled" class="p-ml-2"> 
                        Enable Event Image
                    </label>
                </div>
                <div v-show="draftForm.draft.event_image_enabled" class="p-col-12 p-mt-2">
                    <Dropdown v-model="newsEventImage.selected" :options="newsEventImage.items" optionLabel="name" placeholder="Select Background" class="w-full md:w-14rem" style="width:100%">
                        <template #value="image">
                            <div v-if="image.value.id === 999 || (image.value !== null && image.value.path !== undefined && image.value.path !== null)" class="flex align-items-center">
                                <img :src="image.value.path" :class="`mr-2`" style="width: 64px" />
                            
                                <span v-if="image.value.id !== 999" class="p-ml-2" v-show="image.value.name.length > 0" style="position: relative; bottom: 15px">
                                    {{image.value.name}}
                                </span>
                                <span v-else class="p-ml-2" v-show="image.value.name.length > 0">
                                    {{image.value.name}}
                                </span>
                            </div>
                            <span v-else>
                                {{image.placeholder}}
                            </span>
                        </template>
                        <template #option="image">
                            <div class="flex align-items-center">
                                <div v-if="image.option.path !== undefined && image.option.path !== null" class="flex align-items-center">
                                    <img :src="image.option.path" :class="`mr-2`" style="width: 120px" />
                                
                                    <span class="p-ml-2" v-show="image.option.name.length > 0" style="position: relative; bottom: 35px">
                                        {{image.option.name}}
                                    </span>
                                </div>
                                <span v-else>
                                    {{image.option.name}}
                                </span>
                            </div>
                        </template>
                    </Dropdown>
                    <div class="p-mt-4" v-show="newsEventImage.selected.id === 999">
                        <div class="p-grid p-text-left">
                            <div class="p-field p-col-12">
                                <label for="custom_background">Custom Background</label>
                                <InputText id="custom_background" class="p-col-12" type="text" v-model="newsEventImage.selected.background_url" />
                            </div>
                            <div class="p-field p-col-12" v-show="newsEventImage.selected.background_url !== null && newsEventImage.selected.background_url !== undefined && newsEventImage.selected.background_url !== ''">
                                <Image imageClass="notification-picture p-d-inline" style="width:70% !important;" preview :src="newsEventImage.selected.background_url" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-col-6 p-md-8">
                <div class="p-field">
                    <label for="notification_img_url">Notification Image Url</label>
                    <InputText id="notification_img_url" type="text" v-model="draftForm.draft.notificationImageUrl" style="width:96%;" />
                </div>
                <div class="p-field">
                    <label for="notification_title">Notification Title</label><br/>
                    <Textarea id="notification_title" type="text" rows="1" :autoResize="true" v-model="draftForm.draft.notificationTitle" style="width:96%;" />
                </div>
                <div class="p-field">
                    <label for="notification_subtitle">Notification Subtitle</label><br/>
                    <Textarea id="notification_subtitle" type="text" rows="2" :autoResize="true" v-model="draftForm.draft.notificationSubtitle" style="width:96%;" />
                </div>
                <div class="p-field">
                    <MultiSelect class="" id="notification_categories"
                        v-model="draftForm.draft.notificationCategories" :options="notificationCategories" :filter="true"
                        optionLabel="name" placeholder="Select Categories"
                        style="padding:0 !important; width:96% !important;" />
                </div>
            </div>
        </div>
        <template #footer>
            <div class="p-grid">
                <div class="p-col-3 p-text-left">
                    <Button 
                        label="Reset"
                        v-show="draftForm.mode === 'edit'"
                        @click="resetForm()"
                        class="p-button-text" />
                </div>

                <div class="p-col-6 p-text-center">
                    <Button 
                        :label="draftForm.mode === 'edit' ? 'Save Changes' : 'Add News Lineups Draft'"
                        @click="saveDraft()"
                        class="p-text-bold p-button-info" />
                </div>

                <div class="p-col-3">
                    <Button 
                        label="Close"
                        @click="this.draftForm.isDraftFormVisible = !this.draftForm.isDraftFormVisible"
                        class="p-button-text p-button-info" />
                </div>
            </div>
        </template>
    </Dialog>

    <!-- event selection dialog -->
    <Dialog modal maximizable v-model:visible="popupEventSelection.visible" class="p-col-12 p-md-9 p-mx-auto"
        :header="'Select Event ' + dateToYMD(popupEventSelection.date)">
        <div class="p-grid">
            <div class="p-col-6 p-md-6 p-mx-auto">
                <Listbox v-model="popupEventSelection.selectedCategory"
                    :options="popupEventSelection.categories"
                    optionLabel="category.name"
                    @change="popupEventCategoryChanged()"
                    listStyle="max-height:500px" style="width:100%" />
            </div>
            <div class="p-col-6 p-md-6 p-mx-auto" 
                :visible="popupEventSelection.events !== undefined && popupEventSelection.events !== null">
                <Listbox v-model="popupEventSelection.selectedEvent"
                    :options="popupEventSelection.events"
                    optionLabel="event_info"
                    listStyle="max-height:500px" style="width:100%" />
            </div>
        </div>
        <template #footer>
            <div class="p-grid p-mt-2">
                <div class="p-col-3 p-md-1">
                    <Button label="Clear" 
                        class="p-button-text p-button-danger"
                        @click="popupEventClearSelection()" />
                </div>
                <div class="field p-col-6 p-md-10 p-text-center">
                    <label for="dateformat"></label>
                    <Calendar inputId="dateformat"
                        v-model="popupEventSelection.date"
                        dateFormat="yy-mm-dd"
                        @date-select="popupSelectEvent()" />
                </div>
                <div class="p-col-3 p-md-1">
                    <Button label="Save" @click="popupEventSave()" />
                </div>
            </div>
        </template>
    </Dialog>
</template>

<style>
.event-image-home-logo {
    width: 25px; height: 25px;
    position: absolute; left: 15%; top: 30px;
}

.event-image-away-logo {
    width: 25px; height: 25px;
    position: absolute; right: 15%; top: 30px;
}

.notification-picture {
    float: left;
    width: 100%;
    height: 100px;
    object-fit: contain;
    text-align: center;
    border-radius: 4px;
}

.icon {
  max-width: 24px; max-height:24px;
}

.icon-mini {
  max-width: 18px; max-height:18px;
}
</style>

<script>
import axios from "axios";
import ProgressBar from 'primevue/progressbar'
import Paginator from 'primevue/paginator'
import Button from 'primevue/button'
import Menu from 'primevue/menu'
import Divider from 'primevue/divider'
import Dialog from 'primevue/dialog'
import Textarea from 'primevue/textarea'
import InputText from 'primevue/inputtext'
import Image from 'primevue/image'
import Checkbox from 'primevue/checkbox'
import AutoComplete from 'primevue/autocomplete'
import Listbox from 'primevue/listbox'
import Calendar from 'primevue/calendar'
import MultiSelect from 'primevue/multiselect'
import Dropdown from 'primevue/dropdown'

import { isEmpty } from '../utils/utils'
import Const from '../utils/const'

let SpringApi;
let TeamSuperLigGenel = { id: 0, ss_team_id: 0, name: "Süper Lig Genel" };

export default {
    name: 'NewsLineupsDraft',
    components: {
        Paginator, Button, Menu, ProgressBar, Divider, Dialog, Textarea, InputText, Image,
        Checkbox, AutoComplete, Listbox, Calendar, MultiSelect, Dropdown
    },
    data() {
        return {
            defaultImageUrl: 'https://5.imimg.com/data5/IG/RN/YX/SELLER-81676912/stadium-grass-500x500.jpg',
            newPictureDefaultPlaceholder: 'images/placeholder.png',
            draftForm: {
                draft: {},
                isDraftFormVisible: false,
                imageUrl: "",
                title: "",
                subtitle: "",
                content: "",
                isMiddlePageAdEnabled: false,
                ssEventId: null,
                ssEventInfo: null,
                notificationImageUrl: "",
                notificationTitle: "",
                notificationSubtitle: "",
                notificationCategories: [],
            },
            drafts: {
                currentPage: 0,
                itemPerPage: 20,
                totalCount: 0,
                items: [],
                itemsPerPageOptions: [10, 20, 50],
                isLoading: false,
                firstItemIndex: null,
            },
            draftOptionsMenu: {
                draftObject: null,
                index: null,
                items: null
            },
            menuRefs: {},
            teams: [],
            selectedTeams: [],
			filteredTeams: [],
            notificationCategories: [],
            popupEventSelection: {
                visible: false,
                date: new Date(),
                categories: null,
                selectedCategory: null,
                events: null,
                selectedEvent: null
            },
            newsEventImage: {
                items: this.getEventImagesList(),
                selected: {
                    background_url: null
                }
            }
        }
    },
    emits: ["loginResult", "pageLoaded"],
    beforeUpdate() {
        // Liste güncellenmeden önce, eski DOM elementlerine ait
        // referansları temizle.
        this.menuRefs = {};
    },
    beforeMount() {
        SpringApi = axios.create({
            baseURL : process.env.VUE_APP_SPRING_API_URL,
            headers: {
                'Authorization': 'Bearer ' + this.$cookies.get('token')
            }
        });
        
        var page = {
            title: 'News Lineups Draft'
        }
        this.$emit('pageLoaded', page)
    },
    async mounted() {
        this.drafts.isLoading = true
        await this.loadTeams()

        await this.loadNotificationCategories()
        this.drafts.isLoading = false

        this.listAll()
    },
    methods: {
        setMenuRef(element, index) {
            if (element) {
                this.menuRefs[index] = element;
            }
        },
        async loadTeams() {
            let self = this,
                toast = self.$toast,
                token = self.$cookies.get("token");
            
            try {
                let response = await self.$http.get('api/tournaments/'+Const.TournamentIds.SuperLig+'/teams', {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                });

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili) {
                    let data = response.data;

                    data.items.push(TeamSuperLigGenel);

                    data.items.forEach(team => {
                        team.value = team.id
                        self.teams.push(team)
                        self.filteredTeams.push(team)
                    })
                } else {
                    console.log(response)
                    toast.add({severity:'warn', summary: 'Loading teams failed', detail:response.data.mesaj, life: 3000});
                }
            } catch (error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error', detail:error, life: 3000});
            }
        },
        async loadNotificationCategories() {
            let self = this,
                toast = self.$toast,
                token = self.$cookies.get("token");
            
            try {
                let response = await self.$http.get('api/notification-categories', {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                });

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili) {
                    self.notificationCategories = response.data.items;
                } else {
                    console.log(response)
                    toast.add({severity:'warn', summary: 'Loading notification categories failed', detail:response.data.mesaj, life: 3000});
                }
            } catch (error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error', detail:error, life: 3000});
            }
        },
        async listAll(page = 1, limit = null) {
            let self = this,
                toast = self.$toast;

            try {
                self.drafts.isLoading = true
                let response = await SpringApi.get(`/news-lineups-drafts`, {
                    params: {
                        page: page - 1,
                        limit: limit
                    }
                })
                
                let data = response.data;
                if (data.items !== null && data.items !== undefined) {
                    data.items.forEach((item, index) => {
                        data.items[index] = self.prepareNewsItem(item)
                    })
                }
                self.drafts.items = data.items;
                self.drafts.itemPerPage = data.itemPerPage;
                self.drafts.totalCount = data.totalCount;
                self.drafts.currentPage = page;
                self.drafts.firstItemIndex = (self.drafts.currentPage - 1) * self.drafts.itemPerPage
            } catch (error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error', detail: error, life: 3000});
            } finally {
                self.drafts.isLoading = false
            }
        },
        onPage(event) {
            this.listAll(event.page + 1, event.rows)
        },
        toggleOptions(event, draftObject, index) {
            let draftOptionsMenu = this.draftOptionsMenu;
            draftOptionsMenu.draftObject = draftObject;
            draftOptionsMenu.index = index;

            let optionsMenuItems = []

            optionsMenuItems.push(...[
                {
                    label: 'Delete',
                    icon: 'pi pi-trash',
                    command: () => {
                        this.deleteDraft(draftObject.id)
                    }
                }
            ])

            if(optionsMenuItems.length === 0) {
                optionsMenuItems = [
                    {
                        label: 'None available'
                    }
                ]
            }

            draftOptionsMenu.items = optionsMenuItems

            const menu = this.menuRefs[index];
            if (menu) { // Referansın bulunduğundan emin ol
                menu.toggle(event);
            } else {
                console.error(`Menu ref for index ${index} not found!`);
            }
        },
        prepareNewsItem(news) {
            let teams = this.teams;
            let item = news
            
            let mSelectedTeams = []
            if (!isEmpty(item.ssTeamId)) {
                let team1 = teams.find(t => t.ss_team_id === item.ssTeamId);
                if (team1 !== null && team1 !== undefined) {
                    mSelectedTeams.push({ss_team_id: item.ssTeamId, name: team1.name})
                }
            }
            if (!isEmpty(item.ssTeamId2)) {
                let team2 = teams.find(t => t.ss_team_id === item.ssTeamId2);
                if (team2 !== null && team2 !== undefined) {
                    mSelectedTeams.push({ss_team_id: item.ssTeamId, name: team2.name})
                }
            }
            
            let newsNotificationCategories = []
            var newsNotificationCategoriesNames = ""
            
            if (!isEmpty(item.notificationCategoryIds)) {
                item.notificationCategoryIds.forEach(categoryId => {
                    let notificationCategory = this.notificationCategories.find(c => c.id === categoryId)
                    if (notificationCategory !== null && notificationCategory !== undefined) {
                        newsNotificationCategories.push(notificationCategory);
                    }
                });

                newsNotificationCategoriesNames = newsNotificationCategories.map(cat => cat.name).join(', ');
            }

            item.newsId = item.id
            item.selectedTeams = mSelectedTeams
            item.teams = mSelectedTeams.map(t => t.name).join(', ');
            item.newsNotificationCategories = newsNotificationCategories
            item.newsNotificationCategoriesNames = newsNotificationCategoriesNames

            return item
        },
        getEventImageTeamLogo(eventImage, homeOrAway) {
            var teamId = eventImage.h;
            if (homeOrAway === 'away') {
                teamId = eventImage.a;
            }

            return 'https://api.sofascore1.com/api/v1/team/'+teamId+'/image';
        },
        toggleDraftForm() {
            this.draftForm.isDraftFormVisible = !this.draftForm.isDraftFormVisible;

            if (this.draftForm.isDraftFormVisible) {
                this.draftForm.draft.imageUrl = this.defaultImageUrl;
                this.draftForm.draft.notificationImageUrl = this.defaultImageUrl;
                this.draftForm.draft.event_image_enabled = true;
                this.eventImageEnabledChanged();
            }
        },
        resetForm() {
            this.selectedTeams = []
            this.draftForm.draft = {}
        },
        searchTeams(event) {
            if (!event.query.trim().length) {
                this.filteredTeams = [...this.teams]
            } else {
                this.filteredTeams = this.teams.filter((team) => {
                    return team.name.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }
        },
        async popupSelectEvent() {
            let self = this,
                token = self.$cookies.get('token'),
                popupEventSelection = self.popupEventSelection
            
            popupEventSelection.visible = true

            let response = await self.$http.get(`api/ssevents/categories/${this.dateToYMD(popupEventSelection.date)}`, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            
            popupEventSelection.categories = response.data.categories
        },
        async popupEventCategoryChanged() {
            let self = this,
                token = self.$cookies.get('token'),
                popupEventSelection = self.popupEventSelection,
                selectedCategory = popupEventSelection.selectedCategory

            let response = await self.$http.get(`api/ssevents/category/${selectedCategory.category.id}/scheduled-events/${this.dateToYMD(popupEventSelection.date)}`, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })

            response.data.events?.forEach(element => {
                element.event_info = `${element.homeTeam.name} - ${element.awayTeam.name}`
                if (element.homeScore !== undefined && element.homeScore !== null && element.homeScore.current !== undefined
                    && element.awayScore !== undefined && element.awayScore !== null && element.awayScore.current !== undefined) {
                    element.event_info = `${element.homeTeam.name} ${element.homeScore.current} - ${element.awayScore.current} ${element.awayTeam.name}`
                }
            });

            popupEventSelection.events = response.data.events
        },
        popupEventSave() {
            let popupEventSelection = this.popupEventSelection
            var title = ""
            var subtitle = ""
            var content = ""
            var ssEventId = null
            var ssEventInfo = null
            var notificationCategories = []

            if (popupEventSelection.selectedEvent !== null && popupEventSelection.selectedEvent !== undefined) {
                this.selectedTeams = [];
                notificationCategories = [];

                let { homeTeam, awayTeam } = popupEventSelection.selectedEvent;
                ssEventId = popupEventSelection.selectedEvent.id;

                if (this.teams.find(team => team.ss_team_id === homeTeam.id)) {
                    this.selectedTeams.push(homeTeam)

                    var homeTeamNotificationCategory = this.notificationCategories.find(category => category.topic === ''+homeTeam.id+'')
                    if (homeTeamNotificationCategory) {
                        notificationCategories.push(homeTeamNotificationCategory);
                    }
                }

                if (this.teams.find(team => team.ss_team_id === awayTeam.id)) {
                    this.selectedTeams.push(awayTeam)

                    var awayTeamNotificationCategory = this.notificationCategories.find(category => category.topic === ''+awayTeam.id+'')
                    if (awayTeamNotificationCategory) {
                        notificationCategories.push(awayTeamNotificationCategory);
                    }
                }

                ssEventInfo = homeTeam.name + " - " + awayTeam.name;
                if ([homeTeam.id, awayTeam.id].includes(Const.TeamIds.Turkiye)) {
                    this.selectedTeams.push(TeamSuperLigGenel);
                    title = "";

                    var turkiyeTeamNotificationCategory = this.notificationCategories.find(category => category.topic === '0')
                    if (turkiyeTeamNotificationCategory) {
                        notificationCategories.push(turkiyeTeamNotificationCategory);
                    }
                } else {
                    title = ssEventInfo;
                }

                subtitle = "Mücadelede ilk 11'ler belli oldu..."
                content = Const.LINEUPS_PLACEHOLDER;
            } else {
                this.selectedTeams = []
                title = ""
                subtitle = ""
                content = ""
                ssEventId = null
                ssEventInfo = null
                notificationCategories = []
            }

            this.draftForm.draft.title = title
            this.draftForm.draft.subtitle = subtitle
            this.draftForm.draft.notificationTitle = title
            this.draftForm.draft.notificationSubtitle = subtitle
            this.draftForm.draft.notificationCategories = notificationCategories
            this.draftForm.draft.content = content
            this.draftForm.draft.ssEventId = ssEventId
            this.draftForm.draft.ssEventInfo = ssEventInfo

            popupEventSelection.visible = false
        },
        popupEventClearSelection() {
            this.$confirm.require({
                message: 'Clear event selection for news?',
                header: 'Clear',
                icon: 'pi pi-times-circle',
                acceptLabel: 'Clear',
                rejectLabel: 'Cancel',
                accept: async () => {
                    this.popupEventSelection.selectedCategory = null
                    this.popupEventSelection.selectedEvent = null
                    this.popupEventSelection.events = null
                    this.popupEventSelection.visible = false
                    this.selectedTeams = []
                    this.draftForm.draft.title = ""
                    this.draftForm.draft.notificationTitle = ""
                    this.draftForm.draft.notificationCategories = []
                    this.draftForm.draft.ssEventId = null
                    this.draftForm.draft.ssEventInfo = null
            
                },
                reject: () => {}
            });
        },
        dateToYMD(date) {
            var d = date.getDate();
            var m = date.getMonth() + 1; //Month from 0 to 11
            var y = date.getFullYear();
            return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
        },
        saveDraft() {
            let self = this,
                draftForm = self.draftForm,
                mode = draftForm.mode,
                draftIndex = draftForm.newsIndex
            
            if(mode === 'edit' && !isEmpty(draftForm.id) && draftForm.id > 0) {
                self.updateDraft(draftIndex)
            } else {
                self.addDraft()
            }
        },
        getEventImage() {
            var eventImage = null
            if (this.newsEventImage.selected?.id !== undefined && this.newsEventImage.selected?.id !== null) {

                var tempEventImage = {}
                if (this.newsEventImage.selected?.id === 999) {
                    let backgroundUrl = this.newsEventImage.selected?.background_url
                    if (backgroundUrl === undefined || backgroundUrl === null || backgroundUrl === '') {
                        alert('Image URL can not be null');
                        return null;
                    }

                    tempEventImage.bu = backgroundUrl;
                } else {
                    tempEventImage.br = this.newsEventImage.selected?.id
                }

                if (this.popupEventSelection.selectedEvent === undefined || this.popupEventSelection.selectedEvent === null) {
                    alert('Event can not be null');
                    return null;
                }
                let event = this.popupEventSelection.selectedEvent

                tempEventImage.h = event.homeTeam?.id
                tempEventImage.a = event.awayTeam?.id
                tempEventImage.sid = event.id

                eventImage = tempEventImage
            }

            return eventImage
        },
        async addDraft() {
            let self = this,
                toast = self.$toast,
                draftForm = self.draftForm,
                draft = draftForm.draft,
                notificationCategories = draft.notificationCategories,
                selectedTeams = self.selectedTeams,
                toastMessage = null,
                eventImage = this.getEventImage();

            if(isEmpty(draft.ssEventId) || isEmpty(draft.ssEventInfo)) {
                toastMessage = 'Event is not selected!'
            } else if(selectedTeams === null || selectedTeams === undefined || selectedTeams.length === 0) {
                toastMessage = 'Teams not selected!'
            } else if(isEmpty(draft.imageUrl)) {
                toastMessage = 'Image url is empty!'
            } else if(isEmpty(draft.title)) {
                toastMessage = 'Title is empty!'
            } else if(isEmpty(draft.subtitle)) {
                toastMessage = 'Subtitle is empty!'
            } else if(isEmpty(draft.content)) {
                toastMessage = 'News content is empty!'
            } else if(!draft.content.includes(Const.LINEUPS_PLACEHOLDER)) {
                toastMessage = 'Lineups placeholder is missing. Placeholder: ' + Const.LINEUPS_PLACEHOLDER;
            } else if((draft.content.match(/#LINEUPS#/g) || []).length > 1) {
                toastMessage = 'Lineups placeholder must be written only once!';
            } else if(isEmpty(draft.notificationImageUrl)) {
                toastMessage = 'Notification Image Url is empty!'
            } else if(isEmpty(draft.notificationTitle)) {
                toastMessage = 'Notification Title is empty!'
            } else if(isEmpty(draft.notificationSubtitle)) {
                toastMessage = 'Notification Subtitle is empty!'
            } else if(notificationCategories === null || notificationCategories === undefined || notificationCategories.length === 0) {
                toastMessage = 'Notification Categories not selected!'
            } else if (draftForm.draft.event_image_enabled && (eventImage.h === undefined || eventImage.h === null || eventImage.a === undefined || eventImage.a === null)) {
                toastMessage = 'Team Ids are gone. Reselect the event from Event Selection popup.'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            draft.eventImage = eventImage
            draft.subtitle = draft.subtitle.replaceAll('\n', '<br/>')
            draft.content = draft.content.replaceAll('\n', '<br/>')

            draft.ssTeamId = selectedTeams[0].id
            draft.ssTeamId2 = (selectedTeams.length > 1) ? selectedTeams[1].id : null

            var notificationCategoryIds = []
            notificationCategories.forEach(item => notificationCategoryIds.push(item.id))
            draft.notificationCategoryIds = notificationCategoryIds

            try {
                let response = await SpringApi.post(`/news-lineups-drafts`, draft)

                if(response.status >= 200 && response.status <= 299) {
                    self.drafts.currentPage = 1;
                    self.listAll()
                    this.popupEventSelection.visible = false
                    this.clearDraftForm()
                } else {
                    console.log(response)
                    toast.add({severity: 'error', summary: 'Error', detail: response.statusText});
                }
            } catch (error) {
                console.log(error)
                toast.add({severity: 'error', summary: 'Error', detail: error});
            }
        },
        updateDraft(draftIndex) {
            console.log(draftIndex)
        },
        clearDraftForm() {
            this.draftForm = {
                mode: 'add',
                draft: {},
                isDraftFormVisible: false,
                imageUrl: "",
                title: "",
                subtitle: "",
                content: "",
                isMiddlePageAdEnabled: false,
                ssEventId: null,
                ssEventInfo: null,
                notificationImageUrl: "",
                notificationTitle: "",
                notificationSubtitle: "",
                notificationCategories: [],
            }
            
            this.popupEventSelection.selectedCategory = null
            this.popupEventSelection.selectedEvent = null
            this.popupEventSelection.events = null
            this.popupEventSelection.visible = false
            this.selectedTeams = []
            this.draftForm.draft.title = ""
            this.draftForm.draft.notificationTitle = ""
            this.draftForm.draft.notificationCategories = []
            this.draftForm.draft.ssEventId = null
            this.draftForm.draft.ssEventInfo = null
        },
        deleteDraft(draftId) {
            let self = this,
                toast = self.$toast;
            
            this.$confirm.require({
                message: 'Are you sure you want to delete this news lineups draft?',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: () => {
                    SpringApi.delete('news-lineups-drafts/'+draftId)
                    .then(function (response) {
                        if(!isEmpty(response.status) && response.status >= 200 && response.status <= 299) {
                            self.clearDraftForm()
                            self.draftForm.isDraftFormVisible = false

                            self.listAll()

                            toast.add({severity:'success', summary: 'Success', detail: 'News lineups draft deleted successfully.', life: 3000});
                        } else {
                            console.log(response)
                            toast.add({severity:'warn', summary: 'Deleting news lineups draft failed', detail:response.data.mesaj, life: 3000});
                        }
                    })
                    .catch(function (err) {
                        console.log(err)
                        toast.add({severity: 'error', summary: 'Error', detail: err});
                    });
                },
                reject: () => {
                }
            });
        },
        onImageUrlPaste() {
            let draftForm = this.draftForm;

            if (draftForm.draft.notificationImageUrl === undefined || draftForm.draft.notificationImageUrl === null
                || draftForm.draft.notificationImageUrl.length === 0) {
                if (draftForm.draft.imageUrl !== undefined && draftForm.draft.imageUrl !== null) {
                    draftForm.draft.notificationImageUrl = draftForm.draft.imageUrl
                }
            }
        },
        eventImageEnabledChanged() {
            if (this.draftForm.draft.event_image_enabled) {
                this.newsEventImage.selected = this.newsEventImage.items[0]
            } else {
                this.clearEventImageSelection()
            }
        },
        clearEventImageSelection() {
            this.newsEventImage.selected = {
                background_url: null
            }
        },
        getEventImagesList() {
            return [
                { id: 1, name: '', path: 'images/event_images/event_image_bg_1.jpg' },
                { id: 2, name: '', path: 'images/event_images/event_image_bg_2.jpg' },
                { id: 3, name: '', path: 'images/event_images/event_image_bg_3.jpg' },
                { id: 4, name: '', path: 'images/event_images/event_image_bg_4.jpg' },
                { id: 5, name: '', path: 'images/event_images/event_image_bg_5.jpg' },
                { id: 7, name: 'Şampiyonlar Ligi', path: 'images/event_images/event_image_bg_7.jpg' },
                { id: 6, name: 'Avrupa Ligi', path: 'images/event_images/event_image_bg_6.jpg' },
                { id: 8, name: 'Konferans Ligi', path: 'images/event_images/event_image_bg_8.jpg' },
                { id: 999, name: 'Custom Background Url', path: null },
            ];
        },
        getEventImageSrc(eventImage) {
            let imageSrc = null
            let images = this.getEventImagesList()
            if (eventImage.br !== undefined && eventImage.br !== null) {
                imageSrc = images.find(image => image.id === eventImage.br).path;
            } else if(eventImage.bu !== undefined && eventImage.bu !== null) {
                imageSrc = eventImage.bu
            } else {
                imageSrc = images[0].path
            }

            return imageSrc
        }
    },
    computed: {
        isDraftListEmpty() {
            return this.drafts.items === undefined || this.drafts.items === null || this.drafts.items.length === 0
        }
    }
}

</script>
